import { useUpdateLearnerRequirementStatus } from "@/api/services/main/exam-steps";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { button } from "@/theme/colors";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { Checkbox } from "@mui/material";
import { ChangeEvent, FC, useCallback } from "react";

export const RequirementCheckboxCell: FC<{
  industryId: number;
  learnerId: number;
  requirementId: number;
  checked: boolean;
  isDisabledHandling?: boolean;
}> = ({ industryId, learnerId, requirementId, checked, isDisabledHandling }) => {
  const { mutateAsync, isPending } = useUpdateLearnerRequirementStatus();

  const handleChange = useCallback(
    async (_event: ChangeEvent<HTMLInputElement>, newChecked: boolean) => {
      try {
        await mutateAsync({ industryId, learnerId, requirementId, checked: newChecked });
        toast.success(API_SUCCESS_MESSAGE);
      } catch (error) {
        showError(error);
      }
    },
    [mutateAsync, industryId, learnerId, requirementId],
  );

  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      disabled={isDisabledHandling || isPending}
      size="small"
      sx={{ color: button.primary, "&.Mui-checked": { color: button.primary } }}
    />
  );
};
